import timePeriodsApi from "../../api/timePeriods";
import workloadsApi from "../../api/workloads";

const state = {
  currentTimePeriod: null,
  currentWorkload: null,
  nextWorkload: null,
  nextTimePeriod: null,
  fiscalYearTimePeriod: null
};

const getters = {};

const actions = {
  getCurrentTimePeriod(context) {
    return new Promise((resolve, reject) => {
      timePeriodsApi
        .getCurrentTimePeriod()
        .then(function(response) {
          context.commit("updateCurrentTimePeriod", response.data);
          resolve(response);
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  },

  getFiscalYearTimePeriod(context) {
    return new Promise((resolve, reject) => {
      timePeriodsApi
        .getFiscalYearTimePeriod()
        .then(function(response) {
          context.commit("updateFiscalYearTimePeriod", response.data);
          resolve(response);
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  },

  getCurrentWorkload(context) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadByTimePeriod(state.currentTimePeriod.timePeriodId)
        .then(function(response) {
          if (response.data) {
            context.commit("updateCurrentWorkload", response.data);
          } else {
            context.commit("updateCurrentWorkload", null);
          }
          resolve(response);
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  },

  getNextTimePeriod(context) {
    return new Promise((resolve, reject) => {
      timePeriodsApi
        .getNextTimePeriod()
        .then(function(response) {
          context.commit("updateNextTimePeriod", response.data);
          resolve(response);
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  },

  getNextWorkload(context) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadByTimePeriod(state.nextTimePeriod.timePeriodId)
        .then(function(response) {
          if (response.data) {
            context.commit("updateNextWorkload", response.data);
          } else {
            context.commit("updateNextWorkload", null);
          }
          resolve(response);
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  updateCurrentTimePeriod(state, value) {
    state.currentTimePeriod = value;
  },

  updateFiscalYearTimePeriod(state,value) {
    state.fiscalYearTimePeriod = value;
  },

  updateCurrentWorkload(state, value) {
    state.currentWorkload = value;
  },

  updateNextTimePeriod(state, value) {
    state.nextTimePeriod = value;
  },

  updateNextWorkload(state, value) {
    state.nextWorkload = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
